import { TextInput } from "react-admin";

// value nya di setting di SubtotalInput.js
const TotalInput = ({ ...props }) => {
  return <TextInput {...props} />;
};

export default TotalInput;
